import { render, staticRenderFns } from "./lazyblock_slideshow_fullpage.vue?vue&type=template&id=24a9e2ad&scoped=true"
import script from "./lazyblock_slideshow_fullpage.vue?vue&type=script&lang=js"
export * from "./lazyblock_slideshow_fullpage.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_slideshow_fullpage.vue?vue&type=style&index=0&id=24a9e2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a9e2ad",
  null
  
)

export default component.exports